import { isFieldVendorLevel } from "./homePath";

// El vendedor de campo (rango [4,10], `isFieldVendorLevel`) usa una versión
// reducidísima de la app: solo "Crear acceso" y su supervisión. El mural de
// novedades cuenta cambios de secciones que ese rol NO tiene, y su acuse
// ("Entendido" x N) le bloquea la entrada cada vez que se publica una versión.
// Para él, novedades no existe: ni popup al entrar ni entrada en el menú.
// Nivel ilegible o fuera del rango (null, 99) → SÍ ve novedades (fail-open,
// mismo criterio que el resto de guards de nivel de esta app).
export function isWhatsNewEnabledForLevel(level) {
  return !isFieldVendorLevel(level);
}

// Decide qué hacer al cargar la app respecto al mural de novedades.
// stored: versión vista por última vez (o null la primera vez).
// current: versión actual de la app (CHANGELOG[0].version).
// Se abre siempre que la versión vista no coincida con la actual (incluida la primera
// vez, stored = null): así el usuario ve las novedades al entrar.
export function computeWhatsNewState(stored, current) {
  return { shouldOpen: stored !== current };
}

// Devuelve las versiones del changelog que el usuario aún NO ha visto y que, por tanto,
// requieren acuse ("Entendido"). El changelog está ordenado de más reciente a más antiguo.
// - Sin versión guardada o guardada inexistente (primera vez): solo la más reciente, para
//   no obligar a marcar todo el historial.
// - Versión guardada presente: todas las entradas por encima de ella (las no vistas).
export function computeNewVersions(stored, changelog) {
  if (!Array.isArray(changelog) || changelog.length === 0) return [];
  const idx = changelog.findIndex((e) => e.version === stored);
  if (idx === -1) return [changelog[0].version];
  return changelog.slice(0, idx).map((e) => e.version);
}
